export default "__VITE_ASSET__Dq6IoFoK__"